/* Guide pages (sections/st-guide-article): "On this page" jump links built from the body's h2 headings when there are
   three or more (ids added if missing), the current section marked as the reader scrolls, and wide tables made
   scrollable instead of pushing the page sideways on a phone. Spec: setup/guides-design-spec.md (2026-10-15). */
(function () {
  var body = document.getElementById('st-article-body');
  var toc = document.getElementById('st-article-toc');
  if (!body || !toc) return;

  Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
    if (table.parentElement.classList.contains('st-article__scroll')) return;
    var wrap = document.createElement('div');
    wrap.className = 'st-article__scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (heads.length < 3) return;
  var links = [];
  heads.forEach(function (h, i) {
    if (!h.id) {
      var slug = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      h.id = slug || 'section-' + (i + 1);
    }
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    toc.appendChild(li);
    links.push(a);
  });
  var rail = toc.closest('.st-article__rail');
  if (rail) rail.hidden = false;

  if (!('IntersectionObserver' in window)) return;
  var current = -1;
  var mark = function (i) {
    if (i === current) return;
    current = i;
    links.forEach(function (a, j) { if (j === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  };
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) mark(heads.indexOf(e.target));
    });
  }, { rootMargin: '-80px 0px -65% 0px' });   /* the band a heading lands in after a jump (scroll-margin-top 96px) counts as current */
  heads.forEach(function (h) { io.observe(h); });
})();
